import { render, staticRenderFns } from "./UniversalTable.vue?vue&type=template&id=19b7f638&scoped=true"
import script from "./UniversalTable.vue?vue&type=script&setup=true&lang=js"
export * from "./UniversalTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UniversalTable.vue?vue&type=style&index=0&id=19b7f638&prod&lang=css"
import style1 from "./UniversalTable.vue?vue&type=style&index=1&id=19b7f638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b7f638",
  null
  
)

export default component.exports